import cls from "./Info.module.scss";
import { useTranslation } from "react-i18next";
import Reveal from "../Reveal";
import photo from "./../../images/catInLaptop.jpeg";

function Info() {
    const { t } = useTranslation();
    return (
        <section className={cls.info}>
            <div className={cls.info__box}>
                <div className={cls.info__boxText}>
                    <p className={cls.info__par}>{t("paragraph 1")}</p>
                    <ol className={cls.info__listSmall}>
                        <li className={cls.info__text}>{t("paragraph 2")}</li>
                        <li className={cls.info__text}>{t("paragraph 2.1")}</li>
                        <li className={cls.info__text}>{t("paragraph 2.4")}</li>
                    </ol>
                </div>
                <Reveal animation="flip-in" delay={300}>
                    <img className={`${cls.info__img} hover-gloss-lift`} alt="cat" src={photo} />
                </Reveal>
            </div>
            <p className={cls.info__par}>{t("paragraph 3")}</p>
            <p className={cls.info__par}>{t("paragraph 4")}</p>
            <p className={cls.info__par}>{t("paragraph 4.1")}</p>
        </section>
    );
}

export default Info;
